import { FC, lazy, useCallback, useEffect, useMemo, useState } from "react";
import { Container, GlobalChangeColorWrapper } from "./styles";
import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { ApplicationShared } from "core";
import { LongreadMobileActions } from "../projectEdit/types";
import { Nullable } from "@brg/api";
import { useProfile } from "@brg/auth";
import urlApi from "shared/actions/urlApi";
import { EmptyCategory } from "shared/components/EmptyCategory/EmptyCategory";
import { CHAT_CLOSED_STATUS } from "../teams/components/ChatPermissionEdit";

const LongRead = lazy(() => import('brg-longread').then(module=>({ default: module.LongRead})));

const TeamFeed: FC<{team: any}> = ({ team }) => {
    const theme = useTheme();
    const { t, i18n: { language } } = useTranslation();
    const profile = useProfile();
    const [feedId, setFeedId] = useState<Nullable<string>>();
    const [longReadLength, setLongReadLength] = useState(0);
    const [mobileEditorAction, setMobileEditorAction] = useState<string>(LongreadMobileActions.empty);
    const [mobileEditorOpen, toggleMobileEditor] = useState(false);
    const [mobTextBlockLength, setMobTextBlockLength] = useState<number>(0);

    const isClosedComments = useMemo(() => {
        return team?.channelCommentClosedStatus === CHAT_CLOSED_STATUS.close
    } , [team])

    const handleSetMobTextLengthChange = (val: number) => setMobTextBlockLength(val);

    const [longreadAllowedActions, setLongreadAllowedActions] = useState<any | null>(null);

    const isOwner = useMemo(() => {
        return team?.owners?.[0]?.accountId === profile?.accountId
    } , [profile,team])

    const hasFeed = useMemo(() => {
        return !!team?.owners?.[0]?.feedId
    } , [team])

    const initFeedId = useCallback(async() => {
        if (!hasFeed && isOwner) {
            setFeedId(await urlApi()?.createNewFeed())
            return;
        }
        return setFeedId(team?.owners?.[0]?.feedId)
    } , [team, hasFeed, isOwner])

    const isEditable = useMemo(() => {
        return team?.owners?.[0]?.accountId === profile?.accountId
    } , [team, profile])
    
    useEffect(() => {
    import('brg-longread').then((module) => {
        const allowedActions = [
            'colored',
            'image',
            'big',
            'slider',
            'link',
            'normal',
            'normal_image',
            'normal_card',
            'normal_emblem',
            'course_lesson',
            'podcast',
            'products',
            'multiple',
            'video',
            'special-tools',
            'small',
            'card',
            'audio',
            'buttonLink',
            'twoPictures'
        ]

        setLongreadAllowedActions(allowedActions);
    });
    }, []);

    useEffect(() => {
        initFeedId()
    } , [])

    const emptyMsg = useMemo(() => {
        if (longReadLength === 0 || !hasFeed) {
            return <EmptyCategory text={t('chat.no_posts')} />
        }
        return null;
    } , [t, longReadLength, hasFeed])

    const longread = useMemo(() => {
        if (feedId) {
            return (
                <LongRead
                commentsAllowed={!isClosedComments}
                colorStyle={'light'}
                skipReducedVersion
                onChangeBlocksLength={setLongReadLength}
                projectId={feedId}
                authorId={team?.owners?.[0]?.accountId}
                allowedActions={longreadAllowedActions}
                areaId=""
                isEditable={isEditable}
                countryId=""
                type=""
                isFeed
                longreadId={feedId}
                linkTo="geography"
                shouldDisplayError={longReadLength === 0}
                theme={theme}
                teamId={team?.teamId}
                viewType={'wide'}
                appName={ApplicationShared.application}
                lang={language}
                mobileEditorAction={mobileEditorAction}
                toggleMobileEditor={toggleMobileEditor}
                onSetMobTextLength={handleSetMobTextLengthChange} 
                disableVoting={true}
                coverContent={undefined}
                votesContent={undefined}
                additionalContent={undefined}
                // titleNewPosition={titleNewPosition}
                //временный костыль для теста
                typeConnection={(process.env.REACT_APP_API_CONNECTION_MODE === 'develop' || process.env.REACT_APP_API_CONNECTION_MODE === 'staging') ? 'develop' : process.env.REACT_APP_API_CONNECTION_MODE}
                // teamContexts={(isTeamLg || isThemeEditor) ? undefined : raw?.teams?.map((team: any) => team?.contextName) || []}
                // teamId={(id && isTeamEdit) ? id : isThemeEditor ? currentTeamId : undefined}
                teamExtraFilter={undefined}
                // onOpenSetProjectsModal={(props: any) => modal.show('send-project-longread', {
                // ...props, 
                // project: raw, 
                // // onlyAuthorProjects: true 
                // })}
                canAddAnchors={false}
                isThemeEditor={false}
                onSetThemeAnchors={undefined}
                isLMSMain={false}
                onSetAnchors={undefined}
                // sign={longreadSign}
                lmsModuleInfo={undefined}
                // specBlockProps={{ getProjectHrefPrefix, navigationHandler }}
                isLMSExamEdit={false}
                themeIndex={undefined}
            />
            )
        }
    } , [feedId, language, isClosedComments, team, longReadLength, longreadAllowedActions, isEditable])

    return (
        <Container>
            <GlobalChangeColorWrapper />
            {longread}
            {emptyMsg}
        </Container>
    )
}

export default TeamFeed;import { FC, lazy, useCallback, useEffect, useMemo, useState } from "react";
import { Container, GlobalChangeColorWrapper } from "./styles";
import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { ApplicationShared } from "core";
import { LongreadMobileActions } from "../projectEdit/types";
import { Nullable } from "@brg/api";
import { useProfile } from "@brg/auth";
import urlApi from "shared/actions/urlApi";
import { EmptyCategory } from "shared/components/EmptyCategory/EmptyCategory";
import { CHAT_CLOSED_STATUS } from "../teams/components/ChatPermissionEdit";

const LongRead = lazy(() => import('brg-longread').then(module=>({ default: module.LongRead})));

const TeamFeed: FC<{team: any}> = ({ team }) => {
    const theme = useTheme();
    const { t, i18n: { language } } = useTranslation();
    const profile = useProfile();
    const [feedId, setFeedId] = useState<Nullable<string>>();
    const [longReadLength, setLongReadLength] = useState(0);
    const [mobileEditorAction, setMobileEditorAction] = useState<string>(LongreadMobileActions.empty);
    const [mobileEditorOpen, toggleMobileEditor] = useState(false);
    const [mobTextBlockLength, setMobTextBlockLength] = useState<number>(0);

    const isClosedComments = useMemo(() => {
        return team?.channelCommentClosedStatus === CHAT_CLOSED_STATUS.close
    } , [team])

    const handleSetMobTextLengthChange = (val: number) => setMobTextBlockLength(val);

    const [longreadAllowedActions, setLongreadAllowedActions] = useState<any | null>(null);

    const isOwner = useMemo(() => {
        return team?.owners?.[0]?.accountId === profile?.accountId
    } , [profile,team])

    const hasFeed = useMemo(() => {
        return !!team?.owners?.[0]?.feedId
    } , [team])

    const initFeedId = useCallback(async() => {
        if (!hasFeed && isOwner) {
            setFeedId(await urlApi()?.createNewFeed())
            return;
        }
        return setFeedId(team?.owners?.[0]?.feedId)
    } , [team, hasFeed, isOwner])

    const isEditable = useMemo(() => {
        return team?.owners?.[0]?.accountId === profile?.accountId
    } , [team, profile])
    
    useEffect(() => {
    import('brg-longread').then((module) => {
        const allowedActions = [
            'colored',
            'image',
            'big',
            'slider',
            'link',
            'normal',
            'normal_image',
            'normal_card',
            'normal_emblem',
            'course_lesson',
            'podcast',
            'products',
            'multiple',
            'video',
            'special-tools',
            'small',
            'card',
            'audio',
            'buttonLink',
            'twoPictures'
        ]

        setLongreadAllowedActions(allowedActions);
    });
    }, []);

    useEffect(() => {
        initFeedId()
    } , [])

    const emptyMsg = useMemo(() => {
        if (longReadLength === 0 || !hasFeed) {
            return <EmptyCategory text={t('chat.no_posts')} />
        }
        return null;
    } , [t, longReadLength, hasFeed])

    const longread = useMemo(() => {
        if (feedId) {
            return (
                <LongRead
                commentsAllowed={!isClosedComments}
                colorStyle={'light'}
                skipReducedVersion
                onChangeBlocksLength={setLongReadLength}
                projectId={feedId}
                authorId={team?.owners?.[0]?.accountId}
                allowedActions={longreadAllowedActions}
                areaId=""
                isEditable={isEditable}
                countryId=""
                type=""
                isFeed
                longreadId={feedId}
                linkTo="geography"
                shouldDisplayError={longReadLength === 0}
                theme={theme}
                teamId={team?.teamId}
                viewType={'wide'}
                appName={ApplicationShared.application}
                lang={language}
                mobileEditorAction={mobileEditorAction}
                toggleMobileEditor={toggleMobileEditor}
                onSetMobTextLength={handleSetMobTextLengthChange} 
                disableVoting={true}
                coverContent={undefined}
                votesContent={undefined}
                additionalContent={undefined}
                // titleNewPosition={titleNewPosition}
                //временный костыль для теста
                typeConnection={(process.env.REACT_APP_API_CONNECTION_MODE === 'develop' || process.env.REACT_APP_API_CONNECTION_MODE === 'staging') ? 'develop' : process.env.REACT_APP_API_CONNECTION_MODE}
                // teamContexts={(isTeamLg || isThemeEditor) ? undefined : raw?.teams?.map((team: any) => team?.contextName) || []}
                // teamId={(id && isTeamEdit) ? id : isThemeEditor ? currentTeamId : undefined}
                teamExtraFilter={undefined}
                // onOpenSetProjectsModal={(props: any) => modal.show('send-project-longread', {
                // ...props, 
                // project: raw, 
                // // onlyAuthorProjects: true 
                // })}
                canAddAnchors={false}
                isThemeEditor={false}
                onSetThemeAnchors={undefined}
                isLMSMain={false}
                onSetAnchors={undefined}
                // sign={longreadSign}
                lmsModuleInfo={undefined}
                // specBlockProps={{ getProjectHrefPrefix, navigationHandler }}
                isLMSExamEdit={false}
                themeIndex={undefined}
            />
            )
        }
    } , [feedId, language, isClosedComments, team, longReadLength, longreadAllowedActions, isEditable])

    return (
        <Container>
            <GlobalChangeColorWrapper />
            {longread}
            {emptyMsg}
        </Container>
    )
}

export default TeamFeed;